export default "__VITE_ASSET__0DG2Rqmr__"